import React from "react";

import { HiOutlineUserCircle, HiOutlinePhone, HiOutlineEnvelope } from "react-icons/hi2";

const DisplayOwnerModal = ({ open, onClose, client }) => {
  if (!open) return null;

  return  (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      
      {/* Blackk background */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/30"
      />

      {/* Information Section */}
      <div className="relative z-10 w-[90%] max-w-md rounded-2xl bg-white p-5 shadow-xl">
        <div className="mb-4 flex items-center gap-3">
          <HiOutlineUserCircle className="text-3xl text-gray-700" />
          <h2 className="text-lg font-semibold text-gray-900">
            Client Details
          </h2>
        </div>

        
        <div className="space-y-4">
          <div className="flex items-center gap-3 rounded-lg border p-3">
            <HiOutlineUserCircle className="text-xl text-gray-500" />
            <div>
              <p className="text-xs text-gray-500">Name</p>
              <p className="text-sm font-semibold text-gray-800">
                {client?.name || "-"}
              </p>
            </div>
          </div>

          
          <div className="flex items-center gap-3 rounded-lg border p-3">
            <HiOutlinePhone className="text-xl text-gray-500" />
            <div>
              <p className="text-xs text-gray-500">Phone</p>
              <p className="text-sm font-semibold text-gray-800">
                {client?.phone || "-"}
              </p>
            </div>
          </div>

          
          <div className="flex items-center gap-3 rounded-lg border p-3">
            <HiOutlineEnvelope className="text-xl text-gray-500" />
            <div>
              <p className="text-xs text-gray-500">Email</p>
              <p className="text-sm font-semibold text-gray-800">
                {client?.email || "-"}
              </p>
            </div>
          </div>

        </div>

        <button
          onClick={onClose}
          className="mt-5 w-full rounded-lg bg-gray-900 py-2 text-sm font-semibold text-white hover:bg-black"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default DisplayOwnerModal;
